import { SAUDI_HR_CONFIG } from '../../shared/utils/hrSaudiDefaults';

/** Canonical HR module defaults — synced via useHrConfig / patchSettings. */
export const DEFAULT_HR_CONFIG = { ...SAUDI_HR_CONFIG };

/** Map logical entity keys → hr config field names for getEntityPrefix. */
export const HR_ENTITY_PREFIX_MAP = {
  employee: 'employeeReferencePrefix',
  leave: 'leaveReferencePrefix',
  contract: 'contractReferencePrefix',
  sanction: 'sanctionReferencePrefix',
  departure: 'departureReferencePrefix',
  evaluation: 'evaluationReferencePrefix',
  training: 'trainingReferencePrefix',
  recruitment: 'recruitmentReferencePrefix',
  accident: 'accidentReferencePrefix',
};

/** Map HR config prefixes into settings.configuration.entityPrefixes keys. */
export function buildHrEntityPrefixes(config) {
  const c = normalizeHrConfig(config);
  return {
    employee: c.employeeReferencePrefix,
    leave: c.leaveReferencePrefix,
    contract: c.contractReferencePrefix,
    sanction: c.sanctionReferencePrefix,
    departure: c.departureReferencePrefix,
    evaluation: c.evaluationReferencePrefix,
    accident: c.accidentReferencePrefix,
  };
}

export function normalizeHrConfig(raw = {}) {
  const merged = { ...DEFAULT_HR_CONFIG, ...(raw && typeof raw === 'object' ? raw : {}) };
  return {
    ...merged,
    currency: DEFAULT_HR_CONFIG.currency,
    itemsPerPage: Math.max(1, parseInt(merged.itemsPerPage, 10) || 50),
    employeeReferencePrefix: String(merged.employeeReferencePrefix || 'EMP').trim(),
    leaveReferencePrefix: String(merged.leaveReferencePrefix || 'LEV').trim(),
    contractReferencePrefix: String(merged.contractReferencePrefix || 'CON').trim(),
    sanctionReferencePrefix: String(merged.sanctionReferencePrefix || 'SAN').trim(),
    departureReferencePrefix: String(merged.departureReferencePrefix || 'DEP').trim(),
    evaluationReferencePrefix: String(merged.evaluationReferencePrefix || 'EVA').trim(),
    trainingReferencePrefix: String(merged.trainingReferencePrefix || 'TRN').trim(),
    recruitmentReferencePrefix: String(merged.recruitmentReferencePrefix || 'REC').trim(),
    accidentReferencePrefix: String(merged.accidentReferencePrefix || 'ACC').trim(),
  };
}
